export default { tammikuu: "1.1.2023", heinäkuu: "1.7.2022" };
